import { HttpInsurancePolicyService } from './../../../../../service/http-insurance-policy.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MemberDto } from '../../../../../service/dto';
import { PolicyDto } from '../../../../../service/dto-insurance';
import { Router } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-member-view-policies',
  standalone: false,
  templateUrl: './member-view-policies.component.html',
  styleUrl: './member-view-policies.component.scss'
})
export class MemberViewPoliciesComponent{
	_member!: MemberDto;
	policies: PolicyDto[]=[];
	loading = false;
	constructor(private httpService: HttpInsurancePolicyService,private router: Router){}

	@Input()
	set member(input: MemberDto) {
		this._member = input;
		this.loading=true;
		this.httpService.findByMember(this._member.id).subscribe(
			(result)=>{
				this.policies=result;
				this.loading=false;
			},
			(err)=>{
				this.loading=false;
			}
		);
	}
	get member():MemberDto{
		return this._member;
	}

	openPolicy(policy: PolicyDto) {
		this.router.navigate(['/policy', policy.id]);
	}
}
